/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ProblemDetail,
  ReconcileRequestOut,
  SystemStatusOut
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Сверить остатки сейчас (задача воркера); повтор, пока идёт проверка, — no-op
 */
export const systemReconcileNow = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<ReconcileRequestOut>(
      {url: `/api/v1/system/reconcile`, method: 'POST', ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getSystemReconcileNowMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof systemReconcileNow>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof systemReconcileNow>>, TError,void, TContext> => {

const mutationKey = ['systemReconcileNow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof systemReconcileNow>>, void> = () => {
          

          return  systemReconcileNow(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SystemReconcileNowMutationResult = NonNullable<Awaited<ReturnType<typeof systemReconcileNow>>>
    
    export type SystemReconcileNowMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Сверить остатки сейчас (задача воркера); повтор, пока идёт проверка, — no-op
 */
export const useSystemReconcileNow = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof systemReconcileNow>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof systemReconcileNow>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSystemReconcileNowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Бэкап, воркер и очередь задач, сверка остатков
 */
export const systemGetStatus = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<SystemStatusOut>(
      {url: `/api/v1/system/status`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getSystemGetStatusQueryKey = () => {
    return [
    `/api/v1/system/status`
    ] as const;
    }

    
export const getSystemGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof systemGetStatus>>, TError = ErrorType<ProblemDetail>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetStatus>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSystemGetStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof systemGetStatus>>> = ({ signal }) => systemGetStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof systemGetStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SystemGetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof systemGetStatus>>>
export type SystemGetStatusQueryError = ErrorType<ProblemDetail>


export function useSystemGetStatus<TData = Awaited<ReturnType<typeof systemGetStatus>>, TError = ErrorType<ProblemDetail>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetStatus>>,
          TError,
          Awaited<ReturnType<typeof systemGetStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSystemGetStatus<TData = Awaited<ReturnType<typeof systemGetStatus>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemGetStatus>>,
          TError,
          Awaited<ReturnType<typeof systemGetStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSystemGetStatus<TData = Awaited<ReturnType<typeof systemGetStatus>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetStatus>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Бэкап, воркер и очередь задач, сверка остатков
 */

export function useSystemGetStatus<TData = Awaited<ReturnType<typeof systemGetStatus>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof systemGetStatus>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSystemGetStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




